

import {headers} from "@utils/utils";

const useVideoStore = defineStore('video',() => {

  // stados
  const video = ref({
    id: null,
    nombre: null,
    url: "",
    titulo: "",
    descripcion: "",
    roles:[]
  });


  const videos = ref([]);

  // getters

  const draft = computed(() => clone(video.value));
  // mutations

  const clear = () => {
    video.value = {
      id: null,
      nombre: null,
      url: "",
      titulo: "",
      descripcion: "",
      roles:[]
    };
  };


  const setVideo = (payload) => {
    if(payload){
      video.value = payload;
    }

  };
  
  // actions

  const fetch = (video_id) => {
    return new Promise((resolve, reject) => {
      axios.get(`/api/videos/${video_id}/fetch-data`)
      .then(({data}) => {
        video.value = data;
        resolve(data);
      }).catch(e => {
        reject(e)
      })
    })
  };

  const fetchData = (datos) => {
    return new Promise((resolve, reject) => {
      axios.post(`/api/videos/fetch-data`,datos)
      .then(({data}) => {
        resolve(data);
      }).catch(e => {
        reject(e)
      })
    })
  };


  const guardar = (datos) => {

    let formData = new FormData();

    Object.keys(datos).forEach(key => {
      if(key == 'roles' && Array.isArray(datos[key])){
        datos[key].forEach((r,i) => {
          formData.append(`roles[${i}]`, r);
        })
        return;
      }
      formData.append(key, datos[key]);
    });

    return new Promise((resolve, reject) => {
      
      if(datos.id){
        // actualizado
        formData.append('_method', 'PUT');

        axios.post(`/api/videos/${datos.id}`,formData,headers)
        .then(({data}) => {
          if(data.result) setVideo(data.video);
          resolve(data)
        }).catch(e => reject(e))
      }else{
        // creando
         axios
           .post(`/api/videos`, formData,headers)
           .then(({ data }) => {
              if(data.result) setVideo(data.video);
             resolve(data);
           })
           .catch((e) => reject(e));
      }

    })
  }   


  const eliminar = (tipo_id) => {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/videos/${tipo_id}`)
      .then(({data}) => {
        resolve(data);
      }).catch(e => reject(e));

    })
  }


  return {
    // states
    video,
    videos,
    // getters
    draft,

    // methods or actions
    fetch,
    fetchData,
    guardar,
    eliminar,
    clear,

    setVideo,
  };

});

export default useVideoStore;